import { render } from "./DocumentUpload.vue?vue&type=template&id=53408cee&scoped=true&ts=true"
import script from "./DocumentUpload.vue?vue&type=script&lang=ts"
export * from "./DocumentUpload.vue?vue&type=script&lang=ts"

import "./DocumentUpload.vue?vue&type=style&index=0&id=53408cee&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53408cee"]])

export default __exports__